import { useUserStore } from '@/fsd/entities/user/model/store/useUserStore';
import { ActiveTariffsDaysLeftBlock } from '@/fsd/feature/payments-and-tarrifs/show-active-tarrifs-days-left';
import { MainLogo } from '@/fsd/shared/ui/icons';
import cx from 'classnames';
import { Link } from 'react-router-dom';
import FavoriteMenu from '../FavoriteMenu/FavoriteMenu';
import style from '../header.module.scss';
import HeaderMainMenu from '../HeaderMainMenu/HeaderMainMenu';

const HeaderNavDefault = () => {
  const userStore = useUserStore();

  return (
    <div
      className={cx(
        style['flex'],
        style['jc-sb'],
        style['ai-c'],
        style['gap-20']
      )}
    >
      <div
        className={cx(
          style['header-nav__item'],
          style['header-nav__item--logo']
        )}
      >
        <Link to="/" className={style['header__logo_link']}>
          <MainLogo />
        </Link>
      </div>

      {userStore.isLogged && (
        <>
          {/*<FavoriteMenu />*/}
          <HeaderMainMenu />
        </>
      )}
    </div>
  );
};

export default HeaderNavDefault;
